import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { Divider } from '@waglabs/divider';
import ExternalLink from '@waglabs/link';
import { Typography } from '@waglabs/typography';

import { Step } from '../../../../../../components/Step';
import { Stepper } from '../../../../../../components/Stepper';
import {
  SIGNUP_URL,
  WALKER_LOGIN_URL,
} from '../../../../../../constants';
import {
  withHistory,
  WithHistoryInjectedProps,
} from '../../../../../../hocs/withHistory';
import { useStepper } from '../../../../../../hooks/useStepper';

import { LoginByEmailFormStep1 } from './LoginByEmailFormStep1';
import { LoginByEmailFormStep2 } from './LoginByEmailFormStep2';
import { LoginByEmailFormStep3 } from './LoginByEmailFormStep3';
import { LoginByEmailFormWithSocialLoginsStep } from './LoginByEmailFormWithSocialLoginsStep';

const steps = [
  LoginByEmailFormWithSocialLoginsStep,
  LoginByEmailFormStep1,
  LoginByEmailFormStep2,
  LoginByEmailFormStep3,
];

export type LoginByEmailFormStepperProps = WithHistoryInjectedProps & {
  onComplete?: Function;
};

const LoginByEmailFormStepper = ({
  search,
  onComplete = () => {},
}: LoginByEmailFormStepperProps) => {
  const stepper = useStepper(steps);

  useEffect(() => {
    if (!stepper.isCompleted) {
      return;
    }
    onComplete();
  }, [onComplete, stepper.isCompleted]);

  if (stepper.isCompleted) {
    return null;
  }

  return (
    <>
      <Stepper
        activeStep={stepper.activeStep}
      >
        {steps.map((StepContent) => (
          <Step
            key={StepContent.toString()}
          >
            <StepContent
              {...stepper}
            />
          </Step>
        ))}
      </Stepper>

      {/* Display only on the first step of this login process */}
      {stepper.activeStep === 0 && (
        <>
          <Divider
            mt={0}
          />

          <Typography>
            New user?
            {' '}
            <Link
              data-testid="signup-link"
              to={{
                search,
                pathname: SIGNUP_URL,
              }}
            >
              Sign up now
            </Link>
          </Typography>

          <Typography>
            Are you a Pet Caregiver?
            {' '}
            <ExternalLink
              href={WALKER_LOGIN_URL}
            >
              Login here
            </ExternalLink>
          </Typography>

        </>
      )}
    </>
  );
};

const EnhancedLoginByEmailFormStepper = withHistory(LoginByEmailFormStepper);

export { EnhancedLoginByEmailFormStepper as LoginByEmailFormStepper };
